import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { VideoPlayer } from '../../../video/components';
import { useClip } from '../../contexts/clip/hook';
import { useClipPlayback } from '../../contexts/clip-playback/hook';

export const Video: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { clip, getMessageById, getMessageAtTimestamp } = useClip();
  const { ready, play, currentTime, duration, changeMessagePlaying } = useClipPlayback();
  const [played, setPlayed] = useState(false);

  useEffect(() => {
    const auto = searchParams.get('autoplay');
    const messageId = searchParams.get('messageId');

    if (played) {
      return;
    }

    if (!ready) {
      return;
    }

    if (auto) {
      play();
      setPlayed(true);
      return;
    }

    if (messageId) {
      const message = getMessageById(messageId);
      if (message) {
        const startTime = Number(message.startTime);
        changeMessagePlaying(messageId);
        play(startTime);
        setPlayed(true);
      }
      return;
    }
  }, [searchParams, duration, ready, played]);

  const scrollToRow = (id: string) => {
    changeMessagePlaying(id);
  };

  useEffect(() => {
    const findMessageBeingPlayed = () => {
      if (currentTime === 0) {
        return null;
      }

      const messagePlaying = getMessageAtTimestamp(currentTime);
      if (messagePlaying) {
        return messagePlaying;
      } else {
        return null;
      }
    };

    const messageResult = findMessageBeingPlayed();

    if (messageResult) {
      scrollToRow(messageResult.id);
      return;
    } else {
      /*
        We do this so the current selected
        message is unselected.
      */
      scrollToRow('');
    }
  }, [currentTime, getMessageAtTimestamp, changeMessagePlaying]);

  return <VideoPlayer thumbnailUrl={clip.thumbnailUrl} src={clip.videoUrl} />;
};
